module.exports = __webpack_public_path__ + "img/API Gateway.2b281306.png";